export const DEFAULT_PORT = 8969;
export const SERVER_IDENTIFIER = "spotlight-by-sentry";
export const CONTEXT_LINES_ENDPOINT = "/contextlines";
export const RAW_TYPES = new Set(["attachment", "replay_video", "statsd"]);
export const SENTRY_CONTENT_TYPE = "application/x-sentry-envelope";
